import { createReducer, on } from '@ngrx/store';
import { ProductMaintenance, ProductMaintenancePagination } from '@/app/_core/domain/models/control-panel/product-maintenance.model';
import { setProductMaintenance, setResponseProductMaintenance } from './product-maintenance.actions';

export interface ProductMaintenanceState {
  productMaintenance: ProductMaintenance;
  responseProductMaintenance: ProductMaintenancePagination;
}

export const initialproductMaintenanceState: ProductMaintenanceState = {
  productMaintenance: null,
  responseProductMaintenance: null
};

export const reducer = createReducer<ProductMaintenanceState>(
  initialproductMaintenanceState,
  on(setProductMaintenance, (state, action) => ({
    ...state,
    productMaintenance: action.payload.productMaintenance
  })),
  on(setResponseProductMaintenance, (state, action) => ({
    ...state,
    responseProductMaintenance: action.payload.responseProductMaintenance
  }))
);
